import styled from 'styled-components';
import { StyledDiv, StyledSpan } from '../../../Theme/CommonStyled';

export const StyledCreditCardContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  background-color: ${({ theme }): string => theme.colors.mainBackground};
  border-radius: ${({ theme }): string => theme.radii.xxl};
  border: ${({ theme }): string => theme.borders[0]};
  border-color: ${({ theme }): string => theme.colors.border};
  padding: 14px;
  direction: rtl;
  cursor: pointer;
`;

export const StyledDiscountContainer = styled.div<{ disabled?: boolean }>`
  padding: 8px;
  margin-bottom: 12px;
  border-radius: ${({ theme }): string => theme.radii.xl};
  ${({ theme, disabled }): string =>
    disabled
      ? `
         background-color: ${theme.colors.secondaryBackground};
         color: ${theme.colors.disableColor};
         i:before {
              color:${theme.colors.disableColor}
           }
        `
      : `background-color: ${theme.colors.lightGreen};
         color: ${theme.colors.normalText};`};
`;

export const StyledCodeContainer = styled.div<{ disabled: boolean }>`
  position: relative;
  border-radius: ${({ theme }): string => theme.radii.xl};
  background-color: ${({ theme, disabled }): string =>
    disabled ? theme.colors.secondaryBackground : theme.colors.lightBlue};
  height: 54px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
`;

export const StyledTag = styled(StyledDiv)<{
  type: 'info' | 'discount';
  disabled?: boolean;
}>`
  font-size: ${({ theme }): string => theme.fontSizes[2]};
  border-radius: ${({ theme }): string => theme.radii.xxxl};
  padding: 4px 12px;
  ${({ theme, type, disabled }): string =>
    disabled
      ? `background-color: ${theme.colors.mainBackground};
         color: ${theme.colors.disableColor}`
      : type === 'info'
      ? `background-color: ${theme.colors.secondaryBackground};
         color: ${theme.colors.normalText}`
      : `background-color: ${theme.colors.mainBackground};
         color: ${theme.colors.greenTag}`}
`;

export const StyledCode = styled(StyledSpan)<{
  isHistory?: boolean;
  codeIsCopied: boolean;
}>`
  font-size: ${({ theme }): string => theme.fontSizes[6]};
  letter-spacing: 1.6px;
  color: ${({ theme, isHistory }): string =>
    isHistory ? theme.colors.disableColor : theme.colors.primaryBlue};
  transition: 0.3s;

  ${({ codeIsCopied }): string =>
    codeIsCopied ? `transform: scale(0);` : `transform: scale(1);`}
`;

export const StyledCopiedTag = styled(StyledDiv)<{ codeIsCopied: boolean }>`
  padding: 6px 10px;
  border-radius: ${({ theme }): string => theme.radii.xxxl};
  position: absolute;
  left: 16px;
  z-index: ${({ theme }): number => theme.zIndices[8]};
  transition: 0.3s;

  ${({ codeIsCopied }): string =>
    codeIsCopied ? `transform: scale(1);` : `transform: scale(0);`}
`;
